import * as React from "react";
import { Link } from "react-router-dom";

export interface PipelineTab {
    key: string;
    label: string;
    to: string;
}

const selectedTabClassName =
    "twoverride whitespace-nowrap text-brand-700 bg-brand-100 px-3 py-2 font-semibold rounded-md text-sm";

const tabClassName =
    "twoverride whitespace-nowrap text-gray-500 hover:text-gray-700 hover:bg-gray-50 hover:shadow-sm px-3 py-2 font-semibold rounded-md text-sm";

export const PipelineTabs: React.FC<
    React.PropsWithChildren<{ tabs: PipelineTab[]; selectedKey: string }>
> = ({ tabs, selectedKey, children }) => {
    if (tabs.length === 0) {
        return null;
    }
    return (
        <div className="px-4 pt-2 flex flex-wrap gap-1 lg:gap-2">
            {tabs.map(tab => (
                <Link
                    key={tab.key}
                    to={tab.to}
                    className={
                        tab.key === selectedKey ? selectedTabClassName : tabClassName
                    }>
                    {tab.label}
                </Link>
            ))}
            {children}
        </div>
    );
};
